import { safeDefine } from "../../registration/safe-define.js";
import { MenuElement } from "../../ui/menu/element.js";
//#region src/define/ui/menu.ts
safeDefine(MenuElement);
//#endregion

//# sourceMappingURL=menu.js.map